import { Box } from '@material-ui/core';
import lodash from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import styles from './TaskWindowV4.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import newInboxActions from 'workflow/actions/newInbox';
import { faUpRightAndDownLeftFromCenter, faXmark, faChevronLeft, faChevronRight, faDownLeftAndUpRightToCenter } from '@fortawesome/free-solid-svg-icons';

import { Button, BUTTON } from '../../../../../components/common/Button/Button';
import newInboxSelectors from '../../../../selectors/newInbox';
import { Fragment, memo, useState } from 'react';
import DOARequest from '../../Common/DOARequest/DOARequest';
import EventRequest from '../../Common/EventRequest/EventRequest';
import SDFARequest from '../../Common/SDFARequest/SDFARequest';
import { TASK_TYPES, VIEWS } from '../../../../constants/newInbox';
import { LoadingStatus } from '../../../../../components/common/LoadingStatus/LoadingStatus';


const GetRequestView = memo(
    ({ taskWindowDetailMetadata, isMobileView, changeView, institutionTimezone, onCancelTask, fromSentTask }) => {
        switch (taskWindowDetailMetadata.typeName) {
            case TASK_TYPES.DOA:
                return <DOARequest detail={taskWindowDetailMetadata} isNewV4={true} isMobileView={isMobileView} />;
            case TASK_TYPES.EVENT:
                return <EventRequest detail={taskWindowDetailMetadata} isNewV4={true} isMobileView={isMobileView} />;
            case TASK_TYPES.SDFA:
                return (
                    <SDFARequest
                        changeView={changeView}
                        detail={taskWindowDetailMetadata}
                        institutionTimezone={institutionTimezone}
                        isNewV4={true}
                        isWorkflow={fromSentTask}
                        onCancelTask={onCancelTask}
                        isMobileView={isMobileView}
                    />
                );
            default:
                return <Fragment />;
        }
    }
);

const TasksWindowContent = memo(({ taskWindowDetailMetadata, isMobileView, changeView, institutionTimezone, fromSentTask, onCancelTask }) => (
    <Box padding={isMobileView ? '10px' : '20px'} style={{ overflowY: 'auto' }}>
        <GetRequestView
            taskWindowDetailMetadata={taskWindowDetailMetadata}
            isMobileView={isMobileView}
            changeView={changeView}
            institutionTimezone={institutionTimezone}
            fromSentTask={fromSentTask}
            onCancelTask={onCancelTask}
        />
    </Box>
));
const TaskWindowV4 = memo(({ setExtendTaskWindow,
    setTaskForDetailDisplay,
    taskWindowDetail,
    extendedTaskWindow,
    toggleTaskForMultiSign,
    tasksForMultiSign,
    changeView,
    institutionTimezone,
    taskDetailNext,
    taskDetailPrevious,
    taskTotal,
    currentTaskIndex,
    taskWindowDetailMetadata,
    setTaskForSingleSign,
    taskStatus,
    paginateToNextPage,
    paginateToPreviousPage,
    paginationdata,
    paginationTotal,
    allowSignature = true,
    showCancelButton = false,
    onCancelTask,
    fromSentTask = false,
    isLoading = false,
    isMobileView = false,
    switchTaskLoading = false,
    setTaskMarkAsRead
}) => {
    const [showCancelWindow, setShowCancelWindow] = useState(false);

    const CancelTaskWindow = () => {
        return (
            <Box display="flex" justifyContent='center' alignItems='center' style={{ height: '100%', gap: '20px' }} flexDirection={'column'}>
                Are you sure you want to cancel this task?
                <Box display={'flex'} className={styles.cancelBtns}>
                    <Button
                        className={styles.secondaryConfirmationBtn}
                        onClick={() => { onCancelTask(taskWindowDetailMetadata); }}
                        style={{ textTransform: 'none' }}
                    >
                        Yes
                    </Button>
                    <Button
                        className={styles.secondaryConfirmationBtn}
                        onClick={() => setShowCancelWindow(false)}
                    >
                        No
                    </Button>
                </Box>
            </Box>
        );
    };

    return (
        !lodash.isEmpty(taskWindowDetail) &&
        <Box className={`${styles.taskWindowContaier} ${styles.fadeIn}`}>
            {showCancelWindow ?
                <CancelTaskWindow /> :
                <Fragment>
                    <TaskWindowHeader taskStatus={taskStatus} setExtendTaskWindow={setExtendTaskWindow} onClose={setTaskForDetailDisplay} taskWindowDetail={taskWindowDetail} extendedTaskWindow={extendedTaskWindow} isMobileView={isMobileView} />
                    {switchTaskLoading ?
                        <LoadingStatus loading={true} className={styles.filled} actionLabel='Loading task' /> :
                        <Fragment>
                            <TasksWindowContent
                                taskWindowDetailMetadata={taskWindowDetailMetadata}
                                isMobileView={isMobileView}
                                changeView={changeView}
                                institutionTimezone={institutionTimezone}
                                fromSentTask={fromSentTask}
                                onCancelTask={onCancelTask} />
                            <Box className={styles.taskFooter}>
                                <TaskWindowFooter
                                    taskStatus={taskStatus}
                                    changeView={changeView}
                                    toggleTaskForMultiSign={toggleTaskForMultiSign}
                                    taskWindowDetail={taskWindowDetail}
                                    tasksForMultiSign={tasksForMultiSign}
                                    taskTotal={taskTotal}
                                    taskDetailNext={taskDetailNext}
                                    taskDetailPrevious={taskDetailPrevious}
                                    currentTaskIndex={currentTaskIndex}
                                    setTaskForDetailDisplay={setTaskForDetailDisplay}
                                    setTaskForSingleSign={setTaskForSingleSign}
                                    paginateToNextPage={paginateToNextPage}
                                    paginateToPreviousPage={paginateToPreviousPage}
                                    paginationdata={paginationdata}
                                    paginationTotal={paginationTotal}
                                    allowSignature={allowSignature}
                                    showCancelButton={showCancelButton}
                                    onCancelTask={onCancelTask}
                                    setShowCancelWindow={setShowCancelWindow}
                                    isLoading={isLoading}
                                    isMobileView={isMobileView}
                                    setTaskMarkAsRead={setTaskMarkAsRead}
                                />
                            </Box>
                        </Fragment>
                    }
                </Fragment>
            }
        </Box>
    );
});

const TaskWindowHeader = ({ setExtendTaskWindow, onClose, taskWindowDetail, extendedTaskWindow, taskStatus, isMobileView }) => {
    const formatDateString = (dateString) => {
        if (dateString) {
            const date = moment.utc(dateString);
            const formattedDate = date.format('DD MMM YYYY');
            return formattedDate;
        } else {
            return null;
        }
    };

    const closeTaskWindow = () => {
        onClose(null);
        if (extendedTaskWindow)
            setExtendTaskWindow();
    };
    return (
        <Box className={styles.taskHeader}>
            <Box display="flex" justifyContent="space-between" className={styles.taskHeaderContiner}>
                <div className={styles.taskTitle} title={taskWindowDetail.title}>{taskWindowDetail.title}</div>
                <Box className={styles.taskActionBtnContainer}>
                    {!isMobileView &&
                        <div
                            className={styles.taskActionBtn}
                            onClick={() => setExtendTaskWindow()}
                        >

                            <FontAwesomeIcon icon={extendedTaskWindow ? faDownLeftAndUpRightToCenter : faUpRightAndDownLeftFromCenter} />
                        </div>
                    }
                    <div
                        className={styles.taskActionBtn}
                        onClick={() => closeTaskWindow()}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </div>
                </Box>
            </Box>
            <Box padding={isMobileView ? '0 10px' : '0 20px'}>
                {taskStatus === 'pending' ? (
                    <div className={styles.taskAction}>
                        {taskWindowDetail.actionName}
                    </div>
                ) : (
                    <div>
                        <span className={styles.taskAction}>
                            {taskWindowDetail.actionName}
                        </span>
                        <span className={styles.completedDate}>
                            {' '}(Completed {formatDateString(taskWindowDetail.completedDate)})
                        </span>
                    </div>
                )}
            </Box>
        </Box>
    );
};



const TaskWindowFooter = ({ toggleTaskForMultiSign,
    taskWindowDetail,
    tasksForMultiSign,
    allowSignature,
    taskDetailNext,
    taskDetailPrevious,
    currentTaskIndex,
    setTaskForDetailDisplay,
    setTaskForSingleSign,
    changeView,
    taskStatus,
    paginateToNextPage,
    paginateToPreviousPage,
    paginationdata,
    paginationTotal,
    showCancelButton,
    setShowCancelWindow,
    isMobileView,
    setTaskMarkAsRead
}) => {
    const handleOnClickSingleSign = () => {
        setTaskForSingleSign(taskWindowDetail);
        changeView(VIEWS.TASK_SIGNATURE);
    };

    const handleOnMultiSignSelect = () => {
        !tasksForMultiSign.find(s => s.id == taskWindowDetail.id) && !lodash.isEmpty(taskWindowDetail.nextTask) && handleOnNextClick();
        toggleTaskForMultiSign(taskWindowDetail);
    };
    const handleOnNextClick = () => {
        if (taskWindowDetail.nextTask && !lodash.isEmpty(taskDetailNext)) {
            setTaskForDetailDisplay(taskDetailNext);
        }
        else if (taskWindowDetail.nextTask && lodash.isEmpty(taskDetailNext)) {
            paginateToNextPage();
        }
    };

    const handleOnPreviousClick = () => {
        if (taskWindowDetail.previousTask && !lodash.isEmpty(taskDetailPrevious))
            setTaskForDetailDisplay(taskDetailPrevious);
        else if (taskWindowDetail.previousTask && lodash.isEmpty(taskDetailPrevious)) {
            paginateToPreviousPage();
        }
    };
    const getButtonLabel = () => tasksForMultiSign.find(s => s.id == taskWindowDetail.id) ? isMobileView ? 'Unselect' : 'Unselect for Signature' : isMobileView ? 'select' : 'Select for Signature';

    const isReadRequest = taskWindowDetail.actionKey === 'read_and_acknowledge';
    const handleAcknowledge = async () => {
        const response = await setTaskMarkAsRead(taskWindowDetail);
        if (response) {
            if (taskWindowDetail.nextTask && !lodash.isEmpty(taskDetailNext)) {
                setTaskForDetailDisplay(taskDetailNext);
            } else if (taskWindowDetail.nextTask && lodash.isEmpty(taskDetailNext)) {
                paginateToNextPage();
            } else if (taskWindowDetail.previousTask && !lodash.isEmpty(taskDetailPrevious)) {
                setTaskForDetailDisplay(taskDetailPrevious);
            } else if (taskWindowDetail.previousTask && lodash.isEmpty(taskDetailPrevious)) {
                paginateToPreviousPage();
            } else {
                setTaskForDetailDisplay({});
            }
        }
    };

    return (
        <Box className={styles.taskFooterContainer}>
            <Box className={styles.selectedTasksInfo}>

                <Box className={styles.selectTaskAction} onClick={() => !lodash.isEmpty(taskWindowDetail.previousTask) && handleOnPreviousClick()} style={{ opacity: !lodash.isEmpty(taskWindowDetail.previousTask) ? 1 : 0, cursor: !lodash.isEmpty(taskWindowDetail.previousTask) ? 'pointer' : 'none' }}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </Box>

                <span className={styles.selectTaskCount}>{paginationdata.offset + (currentTaskIndex === null ? paginationdata.limit - 1 : currentTaskIndex) + 1} of {paginationTotal}</span>

                <Box className={styles.selectTaskAction} onClick={() => !lodash.isEmpty(taskWindowDetail.nextTask) && handleOnNextClick()} style={{ opacity: !lodash.isEmpty(taskWindowDetail.nextTask) ? 1 : 0, cursor: !lodash.isEmpty(taskWindowDetail.nextTask) ? 'pointer' : 'none' }}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </Box>
            </Box>
            {taskStatus === 'pending' && (isReadRequest ? (
                <Box className={styles.actionBtnContainer}>
                    <Button
                        variant="contained"
                        className={styles.primaryBtn}
                        bgcolor={BUTTON.BGCOLOR.BLUE}
                        color={BUTTON.COLOR.WHITE}
                        onClick={handleAcknowledge}
                    >
                        Acknowledge
                    </Button>
                </Box>
            ) : allowSignature && (
                <Box className={styles.actionBtnContainer}>
                    <Button
                        className={styles.secondaryBtn}
                        type={BUTTON.SIZE.SECONDARY}
                        bgcolor={BUTTON.COLOR.WHITE}
                        color={BUTTON.COLOR.BLACK}
                        outline={BUTTON.OUTCOLOR.GREY}
                        onClick={handleOnMultiSignSelect}
                    >
                        {getButtonLabel()}
                    </Button>
                    <Button
                        variant="contained"
                        className={styles.primaryBtn}
                        bgcolor={BUTTON.BGCOLOR.BLUE}
                        color={BUTTON.COLOR.WHITE}
                        onClick={() => handleOnClickSingleSign(taskWindowDetail)}
                    >{isMobileView ? 'Sign' : 'Sign This Record'}</Button>
                </Box>
            ))}
            {taskStatus === 'pending' && showCancelButton &&
                <Button
                    className={styles.cancelBtn}
                    type={BUTTON.SIZE.SECONDARY}
                    color={BUTTON.COLOR.WHITE}
                    onClick={() => {
                        setShowCancelWindow(true);
                    }}
                >
                    Cancel Task
                </Button>
            }

        </Box>
    );
};
export const MultiSignForTaskButton = ({ onClick }) => {
    return (<Button
        variant="contained"
        className={styles.primaryBtn}
        bgcolor={BUTTON.BGCOLOR.ORANGE}
        color={BUTTON.COLOR.WHITE}
        onClick={() => onClick(VIEWS.TASK_SIGNATURE)
        }
    > Sign all selected</Button >
    );
};

const mapStateToProps = state => ({
    taskWindowDetailMetadata: newInboxSelectors.getTaskDetail(state) || {},
    taskWindowDetail: newInboxSelectors.getTaskForDetailDisplay(state),
    taskDetailNext: lodash.get(state, 'taskDetailNext', {}),
    taskDetailPrevious: lodash.get(state, 'taskDetailPrevious', {}),
    taskTotal: lodash.get(state, 'tasks', []).length,
    currentTaskIndex: lodash.get(state, 'currentTaskIndex', 0),
    tasksForMultiSign: lodash.get(state, 'tasksForMultiSign', []),
    institutionTimezone: lodash.get(state, 'me.institutionTimezone'),
});

const mapDispatchToProps = {
    changeView: newInboxActions.changeView,
    setTaskForDetailDisplay: newInboxActions.setTaskForDetailDisplay,
    setTaskWindowDetail: newInboxActions.setTaskWindowDetail,
    toggleTaskForMultiSign: newInboxActions.toggleTaskForMultiSign,
    setTaskForSingleSign: newInboxActions.setTaskForSingleSign,
    setTaskMarkAsRead: newInboxActions.setTaskMarkAsRead,
};
export default connect(mapStateToProps, mapDispatchToProps)(TaskWindowV4);